module.exports = __webpack_public_path__ + "img/joystick.f8a21eb1.png";